import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "table table-hover table-borderless" }
const _hoisted_3 = {
  key: 0,
  class: "border-dark border-bottom"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("th", null, "Billede", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("th", null, "Difference", -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Samlet ")
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("th", null, "Navn", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("th", null, "Farve", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("th", null, "Kategori", -1)
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = ["title"]
const _hoisted_17 = {
  key: 0,
  style: {"min-width":"75px"}
}
const _hoisted_18 = ["src", "alt"]
const _hoisted_19 = {
  key: 1,
  class: "container-fluid"
}
const _hoisted_20 = ["value", "onChange"]
const _hoisted_21 = { style: {"min-width":"60px"} }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = ["title"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  class: "d-inline-block text-truncate",
  style: {"max-width":"200px"}
}
const _hoisted_26 = { class: "small" }

import { computed, ComputedRef } from "vue";
import { useMutation, useQuery, useResult } from "@vue/apollo-composable";
import {
  KLODSER_I_FIGUR_FOR_UUID_OPSLAG,
  OPDATER_KLODS_MUTATION
} from "@/constants/graphql";


export default /*#__PURE__*/_defineComponent({
  __name: 'Klodstabel',
  props: {
    visAntalISaet: { type: Boolean },
    visAntalIFigur: { type: Boolean },
    visOverskrift: { type: Boolean },
    klodsliste: null,
    minifigurUuid: null
  },
  emits: ["soegKlodsnavn"],
  setup(__props: any, { emit }: { emit: ({
  (e: "soegKlodsnavn", value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  visAntalISaet?: boolean;
  visAntalIFigur?: boolean;
  visOverskrift?: boolean;
  klodsliste?: any[];
  minifigurUuid?: string;
}



// eslint-disable-next-line


const {
  result: minifigurKlodserResult,
  loading: minifigurKlodserLoading
} = useQuery(
  KLODSER_I_FIGUR_FOR_UUID_OPSLAG,
  () => {
    return { uuid: props.minifigurUuid };
  },
  () => {
    return {
      enabled: props.minifigurUuid != undefined
    };
  }
);

const minifigurKlodser = useResult(
  minifigurKlodserResult,
  undefined,
  data => data.klodser
);

const { mutate: opdaterKlods } = useMutation(OPDATER_KLODS_MUTATION);

const klodser = computed(() => {
  return props.minifigurUuid != undefined
    ? minifigurKlodser.value
    : props.klodsliste;
});
const overskrift = computed(() => {
  return props.visOverskrift != undefined && props.visOverskrift;
});

const klodserKlar: ComputedRef<boolean> = computed<boolean>(() => {
  return props.minifigurUuid != undefined
    ? !minifigurKlodserLoading.value
    : true;
});

function opdaterDifference(uuid: string, difference: number) {
  opdaterKlods({ uuid: uuid, difference: difference });
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_unref(klodserKlar))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("table", _hoisted_2, [
          (_unref(overskrift))
            ? (_openBlock(), _createElementBlock("thead", _hoisted_3, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, [
                    (__props.visAntalISaet || __props.visAntalIFigur)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Antal"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_5, "Lager"))
                  ]),
                  _hoisted_6,
                  _hoisted_7,
                  _createElementVNode("th", null, [
                    _hoisted_8,
                    (__props.visAntalISaet || __props.visAntalIFigur)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, "(Lager)"))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_10,
                  _hoisted_11,
                  _hoisted_12
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(klodser), (klods) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: klods.uuid
              }, [
                _createElementVNode("td", null, [
                  (__props.visAntalISaet)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(klods.setsIndeholderConnection.edges[0].antal), 1))
                    : (__props.visAntalIFigur)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(klods.figursBestaarAfConnection.edges[0].antal), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(klods.beregnetAntal + Number(klods.difference)), 1))
                ]),
                _createElementVNode("td", {
                  "data-bs-toggle": "tooltip",
                  "data-bs-placement": "bottom",
                  title: 'element id: ' + klods.element_id
                }, [
                  _createVNode(_component_router_link, {
                    to: {
                name: 'klodsisaet',
                params: { klodsUuid: klods.uuid }
              },
                    role: "button"
                  }, {
                    default: _withCtx(() => [
                      (klods.url != undefined)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createElementVNode("img", {
                              class: "img-fluid",
                              style: {"float":"left","width":"75px","height":"50px","object-fit":"contain"},
                              src: klods.url,
                              alt: klods.navn
                            }, null, 8, _hoisted_18)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _createVNode(_component_font_awesome_icon, { icon: ['fas', 'image'] })
                          ]))
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ], 8, _hoisted_16),
                _createElementVNode("td", null, [
                  _createElementVNode("input", {
                    type: "number",
                    value: Number(klods.difference),
                    onChange: ($event: any) => (opdaterDifference(klods.uuid, $event.target.value)),
                    style: {"max-width":"4em"}
                  }, null, 40, _hoisted_20)
                ]),
                _createElementVNode("td", _hoisted_21, [
                  _createTextVNode(_toDisplayString(klods.beregnetAntal) + " ", 1),
                  (__props.visAntalISaet || __props.visAntalIFigur)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, " (" + _toDisplayString(klods.beregnetAntal + Number(klods.difference)) + ") ", 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", {
                  "data-bs-toggle": "tooltip",
                  "data-bs-placement": "bottom",
                  title: klods.erDelDels[0].navn
                }, [
                  _createElementVNode("span", {
                    onClick: ($event: any) => (_ctx.$emit('soegKlodsnavn', klods.erDelDels[0].navn)),
                    role: "button",
                    class: "link-dark text-decoration-none"
                  }, [
                    _createElementVNode("span", _hoisted_25, _toDisplayString(klods.erDelDels[0].navn), 1)
                  ], 8, _hoisted_24)
                ], 8, _hoisted_23),
                _createElementVNode("td", null, [
                  _createVNode(_component_router_link, {
                    to: {
                name: 'klodsmedfarve',
                params: { farvekode: klods.harFarvenFarves[0].id }
              },
                    role: "button",
                    class: "link-dark text-decoration-none"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(klods.harFarvenFarves[0].navn) + " ", 1),
                      _createElementVNode("span", _hoisted_26, "(" + _toDisplayString(klods.harFarvenFarves[0].id) + ")", 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _createElementVNode("td", null, _toDisplayString(klods.erDelDels[0].harKategoriKategoris[0].navn), 1)
              ]))
            }), 128))
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})